import React from "react";
import GoogleMapComponent from "./GoogleMapComponent";
import { defaultCenterType, poleType, prioritiesType, setCenterType, setMapType, showInfoTabType } from "../types/customTypes";

const KEY = process.env.REACT_APP_API_KEY;

const MapComponent:React.FC<propTypes> = (props: propTypes) => {
    const mapProps = () => ({
        apiKey: KEY,
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${KEY}&v=3.exp&libraries=geometry,drawing,places`,
        loadingElement: <div style={{ height: "100%" }} />,
        containerElement: <div style={{ height: "90vh" }} />,
        mapElement: <div style={{ height: "100%" }} />,
        showInfoTab: props.showInfoTab,
        resetPoleData: props.resetPoleData,
        resetData: props.resetData,
        ...props,
    });

    return (
      <GoogleMapComponent {...mapProps()} />
    );
}

type propTypes = {
  showInfoTab: showInfoTabType,
  resetPoleData: () => void,
  resetData: boolean,
  defaultCenter: defaultCenterType,
  poles: poleType[],
  allPoles: poleType[],
  defaultZoom: number,
  priorities: prioritiesType,
  markerClickHandler: (a) => void,
  goToSchools: (a) => void,
  goToPoles: (a) => void,
  setCenter: setCenterType,
  setMap: setMapType,
  selectedPoleId: string,
  isImagesLoading: boolean,
	controlImageCreation : (a) => void,
	getMapImage: () => void,
}

export default MapComponent;
